// src/theme.tsx
// Aplica tema e escala de fonte (preferences-store) no <html> e persiste em
// chaves rápidas lidas pelo script inline do index.html (evita flash no reload).
//
// Tema: data-theme seleciona o bloco de tokens (:root / [data-theme=...]); a
// classe .dark é sincronizada para os temas família-escura (dark, startup),
// mantendo válidos os utilitários dark: do Tailwind.
import { useEffect } from "react";
import { usePreferencesStore, DARK_FAMILY, type Theme } from "@/preferences-store";

export function applyTheme(theme: Theme): void {
  const root = document.documentElement;
  root.dataset.theme = theme;
  root.classList.toggle("dark", DARK_FAMILY.has(theme));
}

export function useApplyTheme(): void {
  const theme = usePreferencesStore((s) => s.theme);
  const themePreference = usePreferencesStore((s) => s.themePreference);
  const fontScale = usePreferencesStore((s) => s.fontScale);

  useEffect(() => {
    applyTheme(theme);
    try {
      if (themePreference) localStorage.setItem("edu.theme", themePreference);
      else localStorage.removeItem("edu.theme");
    } catch {
      // ignore
    }
  }, [theme, themePreference]);

  useEffect(() => {
    const root = document.documentElement;
    root.style.fontSize = `${fontScale}px`;
    try {
      localStorage.setItem("edu.fontScale", String(fontScale));
    } catch {
      // ignore
    }
  }, [fontScale]);
}
